import { Component } from "@angular/core";
var DropdownMenu = (function () {
    function DropdownMenu() {
    }
    return DropdownMenu;
}());
export { DropdownMenu };
DropdownMenu.decorators = [
    { type: Component, args: [{
                selector: "clr-dropdown-menu",
                template: "\n        <ng-content></ng-content>\n    ",
                host: {
                    "[class.dropdown-menu]": "true"
                }
            },] },
];
/** @nocollapse */
DropdownMenu.ctorParameters = function () { return []; };
//# sourceMappingURL=dropdown-menu.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/popover/dropdown/dropdown-menu.js
// module id = 200
// module chunks = 4